function parseReadableNumbers(text: string)
{
    return text.replace(/(\d)/g, '$1 ');
}

export {
    parseReadableNumbers,
};